import { of } from './of';
import { concatAll } from '../operators/concatAll';
export function concat(...observables) {
  return concatAll()(of(...observables));
}
